import './css/Mensajes.css';
import axios from 'axios';
import { useState , useEffect} from 'react';
import CONFIG from '../../config';

const URL_LISTAR_MENSAJES = `${CONFIG.API_URL}/listarMensajes.php`;

function MensajeAdjuntos({mensaje_id}){
    const [adjuntos, setAdjuntos] = useState([]);
    
    const data= {
        'id' :  mensaje_id,
        'tipo'  :'ADJUNTOS'
    }

    useEffect( ()=>{
        axios.post(URL_LISTAR_MENSAJES, data)
        .then(res =>{
            console.log('listarmensajesres.data:', res.data);
            if(!res.data.error){ 
                setAdjuntos(res.data);
            }else{
                setAdjuntos([]);                
            }
        })
        .catch(err=>{
            console.log(err);
        })
 
    },[mensaje_id]);

    const handleEventContainerClick = (e) => e.stopPropagation();

    const esImagen = (nombre) => {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(nombre);
    };

    const obtenerIcono = (nombre) => {
        if (nombre.match(/\.pdf$/i)) return "fa-file-pdf";
        if (nombre.match(/\.doc|\.docx$/i)) return "fa-file-word";
        if (nombre.match(/\.xls|\.xlsx$/i)) return "fa-file-excel";
        return "fa-file-lines";
    };

    return(
        <div className="contenedor-adjuntos" onClick={handleEventContainerClick}>
             {adjuntos.map(ad => {
                const url = `${CONFIG.API_URL}/${ad.path_archivo}`;

                return esImagen(ad.nombre_archivo) ? (
                    /* 🖼️ IMAGEN */
                    <a key={ad.id} href={url} target="_blank" rel="noreferrer">
                        <img 
                            src={url}
                            alt={ad.nombre_archivo}
                            className="adjunto-img"
                        />
                    </a>
                ) : (
                    /* 📄 DOCUMENTO */
                    <a 
                        key={ad.id} 
                        href={url} 
                        target="_blank" 
                        rel="noreferrer"
                        className="adjunto-doc"
                    >
                        <i className={`fa-solid ${obtenerIcono(ad.nombre_archivo)} me-2`}></i>
                        <span className="nombre-doc">{ad.nombre_archivo}</span>
                    </a>
                );
            })}
        </div>
    )
};

export default MensajeAdjuntos;